export enum PeriodEnum {
  QUARTERLY = 'QUARTERLY',
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY',
}

export namespace PeriodEnum {
  export const getLabel = (period: PeriodEnum) => {
    switch (period) {
      case PeriodEnum.QUARTERLY:
        return 'common.quarter';
      case PeriodEnum.HOURLY:
        return 'common.hour';
      case PeriodEnum.DAILY:
        return 'common.day';
      case PeriodEnum.WEEKLY:
        return 'common.week';
      case PeriodEnum.MONTHLY:
        return 'common.month';
      case PeriodEnum.YEARLY:
        return 'common.year';
      default:
        return '';
    }
  };
}
